/**
 * WooCommerce Product Additional Fields Module
 */

/**
 * Initialize product additional info tabs
 */
export function initProductTabs() {
    const tabButtons = document.querySelectorAll('.product-additional-info-tabs .tab-button');
    
    tabButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const tabsContainer = this.closest('.product-additional-info-tabs');
            const targetTab = this.dataset.tab;
            
            // Remove active class from all buttons and panels
            tabsContainer.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('active'));
            tabsContainer.querySelectorAll('.tab-panel').forEach(panel => panel.classList.remove('active'));
            
            // Add active class to clicked button and corresponding panel
            this.classList.add('active');
            const targetPanel = tabsContainer.querySelector('#' + targetTab);
            if (targetPanel) {
                targetPanel.classList.add('active');
            }
            
            // Trigger custom event
            document.dispatchEvent(new CustomEvent('productTabChanged', {
                detail: { targetTab, tabsContainer }
            }));
        });
    });
    
    // Auto-expand first tab if no tab is active
    const firstTabContainer = document.querySelector('.product-additional-info-tabs');
    if (firstTabContainer && !firstTabContainer.querySelector('.tab-button.active')) {
        const firstButton = firstTabContainer.querySelector('.tab-button');
        if (firstButton) {
            firstButton.click();
        }
    }
    
    // Keyboard navigation for tabs
    tabButtons.forEach(button => {
        button.addEventListener('keydown', function(e) {
            const buttons = Array.from(this.parentElement.children);
            const currentIndex = buttons.indexOf(this);
            let targetIndex;

            switch(e.which) {
                case 37: // Left arrow
                    e.preventDefault();
                    targetIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
                    buttons[targetIndex].focus();
                    buttons[targetIndex].click();
                    break;
                    
                case 39: // Right arrow
                    e.preventDefault();
                    targetIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
                    buttons[targetIndex].focus();
                    buttons[targetIndex].click();
                    break;
                    
                case 13: // Enter
                case 32: // Space
                    e.preventDefault();
                    this.click();
                    break;
            }
        });
    });
}

/**
 * Initialize FAQ accordion
 */
export function initProductFaqAccordion() {
    const faqButtons = document.querySelectorAll('.faq-question-button');
    
    faqButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const accordion = this.closest('.product-faq-accordion');
            const content = this.nextElementSibling;
            const isActive = this.classList.contains('active');
            
            // Close all other items in this accordion
            accordion.querySelectorAll('.faq-question-button').forEach(btn => btn.classList.remove('active'));
            accordion.querySelectorAll('.faq-answer-content').forEach(answer => {
                answer.classList.remove('active');
                answer.style.display = 'none';
            });
            
            // Toggle current item
            if (!isActive && content) {
                this.classList.add('active');
                content.classList.add('active');
                content.style.display = 'block';
            }
            
            // Trigger custom event
            document.dispatchEvent(new CustomEvent('productFaqToggled', {
                detail: { button: this, content, isOpen: !isActive }
            }));
        });
        
        // Keyboard navigation for FAQ
        button.addEventListener('keydown', function(e) {
            if (e.which === 13 || e.which === 32) { // Enter or Space
                e.preventDefault();
                this.click();
            }
        });
    });
}

/**
 * Utility function to show specific tab
 */
export function showProductTab(tabId, container = null) {
    if (!container) {
        container = document.querySelector('.product-additional-info-tabs');
    }
    
    const targetButton = container?.querySelector(`[data-tab="${tabId}"]`);
    if (targetButton) {
        targetButton.click();
    }
}

/**
 * Utility function to expand specific FAQ item
 */
export function expandFaqItem(index, accordion = null) {
    if (!accordion) {
        accordion = document.querySelector('.product-faq-accordion');
    }
    
    const buttons = accordion?.querySelectorAll('.faq-question-button');
    if (buttons && buttons[index]) {
        buttons[index].click();
    }
}

// Make functions globally available for backward compatibility
if (typeof window !== 'undefined') {
    window.WooCommerceProductTabs = {
        showTab: showProductTab,
        expandFaq: expandFaqItem
    };
}
